export const INITIAL_DATA_URL = `${process.env.VUE_APP_API_URL}/public-trial-booking-data`;

export const TIME_SLOTS_URL = `${process.env.VUE_APP_API_URL}/sats/sales/bookingslots`;

export const SAVE_BOOKINGS_URL = `${process.env.VUE_APP_API_URL}/public-trial-booking`;

export const RESCHEDULE_BOOKINGS_URL = `${process.env.VUE_APP_API_URL}/public-trial-booking/reschedule`;
